import { BreakerOpenError } from './error.js';
const states = new Map();
/**
 * Derive a route key from a URL: host + first N path segments.
 *
 * Treating "first three segments" as the granularity is wide enough that a
 * single slow handler (`/api/ota/streams/:id`) trips the breaker for siblings
 * (`/api/ota/streams/other`) but narrow enough that unrelated areas
 * (`/api/rms/...`) keep working.
 */
export function routeKey(url, segments) {
    try {
        const u = new URL(url, 'http://_dummy_/');
        const parts = u.pathname.split('/').filter(Boolean).slice(0, segments);
        return `${u.host}/${parts.join('/')}`;
    }
    catch {
        return url;
    }
}
function ensure(route) {
    let s = states.get(route);
    if (!s) {
        s = { consecutiveFailures: 0, openedAt: null };
        states.set(route, s);
    }
    return s;
}
/**
 * If the breaker is open and still within the cooldown window, throw
 * `BreakerOpenError`. Once the cooldown elapses, transition to "half-open":
 * clear the failure count and allow exactly one probe through. On the probe's
 * outcome the breaker either closes (success) or re-opens (failure).
 */
export function check(route, policy, now = Date.now()) {
    const s = ensure(route);
    if (s.openedAt === null)
        return;
    const elapsed = now - s.openedAt;
    if (elapsed >= policy.cooldownMs) {
        s.openedAt = null;
        s.consecutiveFailures = 0;
        return;
    }
    throw new BreakerOpenError(route, policy.cooldownMs - elapsed);
}
export function recordSuccess(route) {
    const s = ensure(route);
    s.consecutiveFailures = 0;
    s.openedAt = null;
}
export function recordFailure(route, policy, now = Date.now()) {
    const s = ensure(route);
    s.consecutiveFailures += 1;
    if (s.consecutiveFailures >= policy.failureThreshold) {
        s.openedAt = now;
    }
}
/** @internal — for tests. */
export function _resetBreaker() {
    states.clear();
}
/** @internal — for tests / introspection. */
export function _peekBreaker(route) {
    const s = states.get(route);
    return s ? { ...s } : undefined;
}
//# sourceMappingURL=breaker.js.map